import type { RootStateOrAny } from 'react-redux'
import { useSelector } from 'react-redux'

import { useCollection } from 'hooks/menu-collections'

import { CollectionId } from '../../domains/collections'

export type RecommendationsCollectionForTutorial = {
  shortTitle?: string
}

export const useShowJFYTutorial = (
  recommendationsCollectionOverride?: RecommendationsCollectionForTutorial | null,
) => {
  const jfyTutorialSeen = useSelector(({ tutorial }: RootStateOrAny) =>
    Boolean(tutorial && tutorial.getIn(['viewed', 'justforyou'])),
  )
  const storedRecommendationsCollection = useCollection(CollectionId.Recommendations)
  const recommendationsCollection =
    recommendationsCollectionOverride === undefined
      ? storedRecommendationsCollection
      : recommendationsCollectionOverride

  if (jfyTutorialSeen) {
    return false
  }

  if (!recommendationsCollection) {
    return false
  }

  // previously we used to check if recommendations collection properties had tutorial = jfy
  // in menu v3 this data doesn't exist, but looking at the backend code, it seems that jfy was hardcoded
  return true
}
